<script>
    import { getJWT } from '../../Utilities/Session.svelte';

    import {notifier} from '@beyonk/svelte-notifications';
    import Assessment from '../../Models/assessmentModel';
    import Loader from '../Loader.svelte';

    import {engine} from '../../lib/liquid_engine';

    import { showContextMenu } from '../ContextMenu.svelte';

    import JSONTree from 'svelte-json-tree';

    import CodeEditor from "../Report/CodeEditor.svelte";

    import sortable, {getBeforeAfter} from '../../lib/sortable';

    import Fa from 'svelte-fa';
    import {faBookMedical} from '@fortawesome/free-solid-svg-icons';

    import TemplateSlide from '../../Models/templateSlideModel';
    import { addFormModal } from '../../Forms/ModalFormManager.svelte';
    import { handleError } from '../../Utilities/handlePromise';

    import {session, isAdmin} from '../../Utilities/Session.svelte';

    export let assessment_type;
    export let assessment_type_model;

    $: slides = $assessment_type.report_slides;

    let slide_idx;
    let current_slide;

    let slideBG;

    let template = false;
    let css = "";
    let body = "";
    let javascript = "";
    let rendered_tpl;
    let rendered_css;

    let variables = {};
    let vars = [];

    let selected_option;
    let selected_assessment;
    let error_message = "";

    let loading = false;
    let preview;

    const assessments = Assessment.getAssessmentList();

    const TemplateSlides = TemplateSlide.getList();

    async function selectAssessment() {
        if (!selected_option) return;

        let assessment_model = new Assessment(selected_option);
        selected_assessment = assessment_model.getAssessmentStore();

        setSlideBackground()
    }

    async function setSlideBackground () {
        if (!(slide_idx != undefined && slideBG && $selected_assessment)) return;

        let assigns = '';

        if (template) {
            console.log(template);

            for (let variable of vars) {
                assigns += `{% assign ${variable} = ${variables[variable]} %}\n`;
            }
        }

        try {
            rendered_tpl = await engine.parseAndRender(assigns + body, {...$selected_assessment, slide_number: slide_idx + 1});
            rendered_css = await engine.parseAndRender(assigns + css, {...$selected_assessment, slide_number: slide_idx + 1});
        } catch (e) {
            error_message = e.message;
            return
        }

        try {
            slideBG.contentDocument.getElementById("global_css").innerHTML = $assessment_type.details.global_css;

            slideBG.contentDocument.getElementsByTagName("body")[0].innerHTML = rendered_tpl;
            slideBG.contentDocument.getElementById("custom_css").innerHTML = rendered_css;

            slideBG.contentWindow.render(slide_idx + 1);
        } catch (e) {
            console.info("Not Ready")
        }

        error_message = "";
    }


    async function generate_preview() {
        let jwt = await getJWT();

        loading = true;

        let res = await fetch('/generate/preview/', {
            method: "POST",
            body: JSON.stringify({
                body: rendered_tpl,
                css: rendered_css,
                global_css: $assessment_type.details.global_css
            }),
            headers: {
                'Authorization': `Bearer ${jwt}`,
                "content-type": "application/json"
            }
        });

        if (res.status != 200) {
            notifier.danger(res.statusText);
        } else {
            res.blob().then((blob) => {
                preview = URL.createObjectURL(blob);
            })
        }

        loading = false;
    }

    function addSlide() {
        assessment_type_model.addSlide({
            body: "",
            css: ""
        })
    }

    function addTemplateSlide() {
        let template_slides = $TemplateSlides.map(ts => {return {label: ts.name, value: ts._id}})

        addFormModal({
            fields: [
                {
                    name: "template",
                    label: "Template Slide",
                    type: "select",
                    choices: {
                        static: template_slides
                    },
                    required: true
                }
            ],
            title: "Select Template Slide"
        }).then((data) => {
            assessment_type_model.addSlide({
                slide_type: "template_slide",
                template_id: data.template
            }).then(() => {
                notifier.success("Template Slide Added")
            })
        }, handleError)
    }

    function removeSlide(slide) {
        if (slides[slide_idx] == slide) {
            slide_idx = undefined;
        }

        assessment_type_model.removeSlide(slide).then(() => {
            notifier.success("Slide Removed");
        })
    }

    async function selectSlide(idx) {
        current_slide = slides[idx];
        if (slides[idx].slide_type == "template_slide") {

            let slide_template = await TemplateSlide.getStatic(slides[idx].template_id);
            template = slide_template.details.name;

            console.log(slide_template)
            body = slide_template.details.body;
            css = slide_template.details.css;

            vars = slide_template.details.vars;
            variables = slide_template.details.default_defs;

            if (current_slide.variables) {
                Object.assign(variables, current_slide.variables);
            }
        } else {
            template = false;

            body = slides[idx].body || '\n\n\n';
            css = slides[idx].css || '\n\n\n';
        }

        slide_idx = idx;

        setSlideBackground();
    }

    function saveSlide() {
        if (template) {
            slides[slide_idx].vars = vars;
            slides[slide_idx].variables = variables;
        } else {
            slides[slide_idx].body = body;
            slides[slide_idx].css = css;
        }

        assessment_type_model.saveSlide(slides[slide_idx]).then(() => {
            notifier.success("Slide saved");
        });
    }

    function handleSlideRightClick(evt, slide) {
        showContextMenu(evt.clientX, evt.clientY, [
            {
                name: "Delete Slide",
                action: () => removeSlide(slide)
            }
        ])
    }

    async function moveSlide(evt) {
        if (evt.newIndex == evt.oldIndex) return;

        let slides = $assessment_type.report_slides;

        let {before, after} = getBeforeAfter(slides, evt.oldIndex, evt.newIndex);

        assessment_type_model.moveSlide(slides[evt.oldIndex], after, before).then(() => {
            slide_idx = evt.newIndex;
        });
    }


    $: setSlideBackground(slideBG, $selected_assessment, body, css, variables)
    $: selectAssessment(selected_option);

    $: filtered_assessments = $assessments?.filter((a) => a.assessment_type_id == $assessment_type.details._id && ($isAdmin || !a.users || a.users.includes($session.user.email)));
</script>


<Loader loading={!slides || loading}>
    <div class="container is-fluid">
        <div class="columns">
            <div class="column is-narrow">
                Slides:
                <ul class="slides" use:sortable={{filter: '.nosort'}} on:sortEnd={(evt) => moveSlide(evt.detail)}>
                    {#each slides as slide, idx (slide._id)}
                        <li class="slide" class:selected={idx == slide_idx} on:click="{() => selectSlide(idx)}" on:contextmenu|preventDefault={(evt) => handleSlideRightClick(evt, slide)}>{idx + 1}</li>
                    {/each}
                    <li class="slide nosort" on:click="{addSlide}">
                        +
                    </li>
                    <li class="slide nosort" on:click="{addTemplateSlide}">
                        <Fa icon={faBookMedical} />
                    </li>
                </ul>
            </div>
            <div class="column">
                {#if slide_idx >= 0}
                    <div class="columns">
                        {#if template}
                            <div class="column is-8">
                                <h1 class="title is-1">{template}</h1>
                                <h2 class="title is-2">Variables</h2>
                            </div>
                        {:else}
                            <div class="column is-4">
                                <h2 class="title is-2">HTML Template</h2>
                            </div>
                            <div class="column is-4">
                                <h2 class="title is-2">CSS Template</h2>
                            </div>
                        {/if}
                            <div class="column is-4">
                                <h2 class="title is-2">Data</h2>
                            </div>
                    </div>
                    <div class="columns source">
                        {#if template}
                            <div class="column is-8 variables">
                                <ul class="variables">
                                    {#each vars as variable}
                                        <li class="card">
                                            <div class="variable_name">{variable}</div>
                                            <div>
                                                <input type="text" bind:value={variables[variable]} class="input">
                                            </div>
                                        </li>
                                    {/each}
                                    <li class="buttons is-right">
                                        <a class="button is-info" href="#/TemplateSlides/{current_slide.template_id}">Edit Template</a>
                                    </li>
                                </ul>
                            </div>
                        {:else}
                            <div class="column is-4">
                                <CodeEditor lang="liquid" bind:value={body} readonly={template} />
                                <!-- CodeMirror bind:value={body} lang={html({nestedLanguages: [liquidlang()]})} lineWrapping={true} readonly={template} />-->
                            </div>
                            <div class="column is-4">
                                <CodeEditor lang="css" bind:value={css} readonly={template}/>
                                <!--<CodeMirror bind:value={css} lang={csslang()} lineWrapping={true} readonly={template} />-->
                            </div>
                        {/if}
                        <div class="column is-4">
                            <Loader loading={!filtered_assessments}>
                                <div class="select">
                                    <select bind:value={selected_option}>
                                        {#each filtered_assessments as assessment}
                                            <option value={assessment}>{assessment.name}</option>
                                        {/each}
                                    </select>
                                </div>
                            </Loader>
                            {#if $selected_assessment}
                                <JSONTree value={$selected_assessment}></JSONTree>
                            {/if}
                        </div>
                    </div>
                    <div>
                        <div class="buttons">
                            <button class="button is-primary" on:click={generate_preview}>Preview Slide</button>
                            <button class="button is-success" on:click={saveSlide}>Save Slide</button>
                        </div>
                        <div class="slide">
                            <iframe src="/slide_preview.html" bind:this={slideBG} title="Slide Background" on:load={setSlideBackground}></iframe>
                        </div>
                        <span class="has-text-error">{error_message}</span>
                    </div>
                {/if}
            </div>
        </div>
    </div>
</Loader>

{#if preview}
<div class="modal is-active" on:click={() => preview = undefined}>
    <div class="modal-background"></div>
    <div class="modal-content">
        <img alt="slide_preview" src="{preview}" on:load={() => URL.revokeObjectURL(preview)}>
    </div>
</div>
{/if}

<style>
    .modal-content {
        width: 720px;
    }

    .slide {
        border: 1px solid gray;
        height: 7.52in;
        width: calc(13.333in + 19px);
        position: relative;
        margin-top: 1em;
    }

    .container {
        padding-top: 32px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .source :global(.container) {
        padding: 0;
    }

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: none;
    }

    .source .column {
        height: 450px;
        overflow: auto;
    }

    li.slide {
        display: block;
        height: 2em;
        width: 3em;
        border: 1px solid lightgray;
        cursor: pointer;
        text-align: center;
        margin-bottom: .5em;
    }

    li.slide.selected {
        background-color: lightcyan !important;
    }

    li.slide:hover {
        background-color: aliceblue;
    }

    .variables li {
        margin-top: 5px;
        padding: 10px;
    }

    .variable_name {
        font-weight: bold;
        margin-bottom: 3px;
    }
</style>